import { EventEmitter, inject,Injectable } from '@angular/core';
import { HttpService, Search } from '@docpath/linces-angular-components/common';

import { EndPoints } from '../../../../constants/end-points';
import { AlertRule } from '../models/alert-rule';

@Injectable({
    providedIn: 'root'
})
export class AlertRulesHttpService {

    readonly relativeUrl = `${EndPoints.ENDPOINT_WEB_API}/${EndPoints.ENDPOINT_CONFIGURATION}/${EndPoints.ENDPOINT_CONFIGURATION_ALERT_RULES}`;

    showLoadingChanged: EventEmitter<boolean> = new EventEmitter();

    private readonly toastPrefix = 'alert-rules-config.toast';

    private readonly httpService = inject(HttpService);

    getAlertRules(search: Search, suscribe: (result: AlertRule[], totalSize: number) => void): void {

        const searchBase64 = btoa(JSON.stringify(search));
        this.showLoadingChanged.emit(true);
        this.httpService.get({
            relativeUrl: this.relativeUrl,
            queryParameters: { search: searchBase64 },
            suscribe: response => {
                const responseBody = response.result as unknown as Search,
                    result = responseBody.result as AlertRule[],
                    totalSize = responseBody.paginator?.totalSize ?? 0;
                this.showLoadingChanged.emit(false);
                suscribe(result, totalSize);
            },
            suscribeOnError: () => {
                this.showLoadingChanged.emit(false);
            }
        });

    }

    createAlertRule(alertRule: AlertRule, suscribe: () => void): void {
        this.httpService.post(alertRule, {
            relativeUrl: this.relativeUrl,
            loading: true,
            suscribe,
            toast: `${this.toastPrefix}.create-success`
        });
    }

    deleteAlertRules(alertRulesIds: number[], suscribe: () => void): void {
        this.httpService.delete({
            relativeUrl: `${this.relativeUrl}`,
            queryParameters: { ids: alertRulesIds },
            loading: true,
            suscribe,
            toast: `${this.toastPrefix}.delete-success`
        });
    }

    editAlertRule(alertRule: AlertRule, suscribe: () => void): void {
        this.httpService.put(alertRule, {
            relativeUrl: this.relativeUrl,
            loading: true,
            suscribe,
            toast: `${this.toastPrefix}.update-success`
        });
    }
}